export default "__VITE_ASSET__ebed39f3__"